<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="project-overview">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @bidderChange="bidderChange"
        @bidTitleChange="bidTitleChange"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          @handleSelectionChange="handleSelectionChange"
          @dblclickEvent="dblclickEvent"
          :loading="loading"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="true"
          :columns="tableColumns"
          @handleSizeChange="() => getTableData()"
          @handleCurrentChange="() => getTableData()"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            align="center"
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'projectStatus'">
                {{ getStatusName(scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'projectSourceType'">
                {{ getProjectSourceType(scope.row[item.field]) }}</span
              >
              <template v-else-if="item.field == 'oaUrl'">
                <a
                  href="javascript:void(0);"
                  v-if="scope.row[item.field]"
                  @click="goOaLink(scope.row[item.field])"
                  >查看</a
                >
              </template>
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <ProjectRevokeDialog
        ref="revokeDialogRef"
        @handleSure="handleRevoke"
        @handleClose="handleCloseRevoke"
      ></ProjectRevokeDialog>
      <ProjectToContractDialog
        ref="toContractDialogRef"
        @handleSure="handleConvert"
        :serviceTypeCode="this.selectedItems[0].serviceTypeCode"
        v-if="this.selectedItems.length > 0"
        @handleClose="handleCloseContract"
      ></ProjectToContractDialog>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import ProjectServiceMixin from '../mixins/projectServiceMixin';
  import ProjectCommonMixin from '../mixins/projectCommonMixin';
  import tableMixins from '@/common/mixins/table.js';
  import { searchColumns } from './columns/searchColumns';
  import { defaultTableColumns } from './index.js';
  import ProjectRevokeDialog from './components/projectRevokeDialog';
  import ProjectToContractDialog from './components/projectToContractDialog';
  import BASE_API from '@/api/dataBase.js';
  // import API from '@/api/masterData/personnel';
  export default {
    name: 'ProjectList',
    mixins: [ProjectServiceMixin, tableMixins, ProjectCommonMixin],
    data() {
      return {
        loading: false,
        tableColumns: [], //表格的表头
        queryData: {
          applyDate: '',
          applyDepartmentNo: '',
          bidClosingDate: '',
          bidOpeningDate: '',
          bidTitle: '',
          bidderId: '',
          projectCode: '',
          projectEndDate: '',
          projectName: '',
          projectSourceType: '',
          projectStartDate: '',
          serviceTypeCode: '',
        },
        menuButtonList: [], // 表格功能按钮
        tableData: [], // 表格数据:
        selectedItems: [],
        departmentList: [],
        companyList: [],
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      // this.queryData.bidTitle = this.userInfo.userInfo.companyName;
      this.getTableData();
      this.getButtonList();
      this.getCompany();
    },
    methods: {
      //获取全部部门数据
      async getDepartment(code) {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: code,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo?.map((item) => {
              return {
                ...item,
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            console.log(this.departmentList, 'this.departmentList');
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取公司数据
      async getCompany() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        console.log('params', params);
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            console.log(res.data.data.personCompanyInfo);
            // 获取公司下拉
            this.companyList =
              res.data.data.personCompanyInfo?.map((item) => {
                return {
                  ...item,
                  value: item.personCompanyCode,
                  label: item.personCompanyName,
                };
              }) || [];
            // 设置默认选中
            console.log(this.queryData.bidTitle, 'this.queryData.bidTitle');
            this.getDepartment(this.queryData.bidTitle);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        // this.queryData = {
        //   bidTitle: this.userInfo.userInfo.companyName,
        // };
        this.getTableData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row, 'selectedItems');
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      //作废确定按钮
      async handleRevoke(invalidReason, remarks) {
        console.log(invalidReason, remarks);
        await this.revoke(this.selectedItems[0].projectCode, invalidReason, remarks);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      // 作废取消按钮
      handleCloseRevoke() {
        this.$refs.siruiTable.clearCheckboxReserve();
      },
      //项目转合同确定按钮
      handleConvert(contractType) {
        this._convert(
          contractType,
          this.selectedItems[0].projectCode,
          this.selectedItems[0].projectName
        );
      },
      // 项目转合同取消按钮
      handleCloseContract() {
        this.$refs.siruiTable.clearCheckboxReserve();
      },
      //列表双击
      dblclickEvent({ row }) {
        this.toDetail(row.projectCode, row.serviceTypeName, 'detail');
      },
      toDetail(projectCode, serviceTypeName, origin = 'create') {
        let query = {};
        let title = '';
        let suffix = 'projectCreates';
        query.pageMode = 1;
        query.origin = origin;
        if (origin == 'create') {
          title = '新建项目';
          query.pageMode = 0;
        } else if (origin == 'copy') {
          title = '新建项目';
          query.projectCode = projectCode;
        } else if (origin == 'detail') {
          title = '项目详情';
          query.serviceTypeName = serviceTypeName;
          query.projectCode = projectCode;
        }
        if (origin == 'detail') {
          suffix = 'projectDetails';
        }
        query.suffix = suffix;
        let path = {
          path: '/park/warehouse/' + suffix,
          name: suffix,
          meta: {
            keepAlive: false,
            title: title,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      bidderChange(rows) {
        if (rows.val) {
          console.log(rows.val[0]);
          this.queryData.bidderId = rows.val[0].id;
        }
      },
      async getCompanyList() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.userInfo.userInfo.companyCode,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        // console.log(res.data.data.personDepartmentInfo,'personDepartmentInfo');
        let personDepartmentInfo = res.data.data.personDepartmentInfo?.map((item) => {
          return {
            ...item,
            value: item.personDepartmentCode,
            label: item.personDepartmentName,
          };
        });
        // console.log(personDepartmentInfo);
        return personDepartmentInfo;
      },
      translateBidTitle(val) {
        console.log(val, 'vale');
        return this.companyList.find((item) => item.value == val)?.label;
      },
      async bidTitleChange(rows) {
        console.log(rows.val, 'rows.val');
        this.queryData = {
          ...this.queryData,
          bidTitle: this.translateBidTitle(rows.val),
          applyDepartmentNo: '',
        };
        // this.queryData.bidTitle = this.translateBidTitle(rows.val);
        // this.queryData.applyDepartmentNo=null;
        this.getDepartment(rows.val);
      },
      // 表格上面的按钮
      chooseClick(type) {
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        // ZT01: '草稿', ZT02: '已作废',ZT03: '审批中',ZT04: '审批通过', ZT05: '项目执行中',ZT06:'审批驳回'
        let projectStatus = justOne ? this.selectedItems[0].projectStatus : '';
        let projectCode = justOne ? this.selectedItems[0].projectCode : '';
        let statusName = this.getStatusName(projectStatus);
        console.log(statusName, 'statusName');
        console.log(projectCode, 'projectCode');
        console.log('listStatus', empty, justOne);
        if (type == 'create') {
          // TODO 判断必须要选择行才可以跳转
          this.toDetail(null, type);
        } else if (type == 'revoke') {
          if (justOne) {
            if (statusName == '审批通过') {
              this.$refs.revokeDialogRef.openDialog();
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: '请选择审批通过的数据!',
              });
            }
          } else {
            this.$message({ showClose: true, type: 'error', message: '请勾选一条数据!' });
          }
        } else if (type == 'convert') {
          if (justOne) {
            if (statusName == '审批通过' || statusName == '项目执行中') {
              // console.log(this.selectedItems[0].serviceTypeCode, 'serviceTypeCode');
              this.$refs.toContractDialogRef.openDialog();
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: '请选择审批通过的数据!',
              });
            }
          } else {
            this.$message({ showClose: true, type: 'error', message: '请勾选一条数据!' });
          }
          //  this.toDetail(projectCode, 'copy');
        } else if (type == 'copy') {
          if (justOne) {
            if (statusName == '已作废') {
              this.toDetail(projectCode, '', 'copy');
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: '请选择已作废的数据!',
              });
            }
          } else {
            this.$message({ showClose: true, type: 'error', message: '请勾选一条数据!' });
          }
        } else if (type == 'withdrawApprovalHandler') {
          if (!this.selectedItems.length) {
            this.$message.error('请选择行');
            return false;
          }
          if (this.selectedItems.some((item) => item.projectStatus != 'ZT03')) {
            this.$message.error('只有审批中才可以撤回审批');
            return;
          }
          // this.loading.startLoading();
          this.loading = true;
          this.$axios
            .post(
              '/sales/wm/project/withdrawOA',
              this.selectedItems.map((item) => item.id)
            )
            .then((res) => {
              console.log(res);
              // this.loading.endLoading();
              this.loading = false;
              const { code, msg } = res.data;
              if (code == 0) {
                this.$message.success('撤回成功');
                this.searchTrigger();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => {
              // this.loading.endLoading();
              this.loading = false;
            });
        }
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns).then(() => {
          this.tableColumns = defaultTableColumns;
        });
      },
      // 获取表格数据
      async getTableData() {
        let params = {};
        params = this.queryData;
        console.log(this.userInfo, 'this.userInfo');
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.adminFlag = this.userInfo.adminFlag;
        // params.bidTitle = this.userInfo.companyName;
        this.loading = true;
        var res = await this.getData(this.filterEmpty(params));
        if (res) {
          this.tableData = res.list || [];
          //清空选择fixme
          this.$refs.siruiTable.setPageTotal(res.total);
          // this.$refs.siruiTable.setPageSize(res.size);
          this.selectedItems = [];
        }
        this.loading = false;
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
    },
    components: {
      SiruiSearch,
      ProjectRevokeDialog,
      ProjectToContractDialog,
    },
  };
</script>

<style lang="scss" scoped></style>
